import Config from '../../config';

const clientId = Config.Auth.ClientId;
const tenantId = Config.Auth.TenantId;
const b2cTenant = Config.Auth.Tenant;
/**
 * The redirect forwarder (account-common/auth/site/redirect.html in the account's auth bucket) each
 * per-branch environment signs in through. It sends the browser back to the branch named in the
 * sign-in state.
 */
const branchRedirectForwarderByEnvironment = {
    Development: 'https://s3.amazonaws.com/account-common-auth.dev.app.squaredup.com/redirect.html',
    EUDevelopment: 'https://s3.eu-west-1.amazonaws.com/account-common-auth.eudev.app.squaredup.com/redirect.html'
};

/** Whether sign-in returns through a redirect forwarder, which needs the branch's URL in the sign-in state. */
export const usesBranchRedirectForwarder = Boolean(branchRedirectForwarderByEnvironment[Config.Environment]);

const redirectUri = branchRedirectForwarderByEnvironment[Config.Environment] ?? window.location.origin;

const b2cPolicies = {
    signUp: 'B2C_1A_SignUpSignInAAD',
    passwordReset: 'B2C_1A_PasswordReset'
};

export function buildAuthority(policy) {
    return `https://${b2cTenant}.squaredup.com/${tenantId}/${policy}`;
}

export const config = {
    b2cPolicies,
    clientId,
    redirectUri
};
